import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

export enum PaymentKey {
  UPLOAD_PAYROLL_FILE = "upload-payroll-file",
  UPLOAD_PROOF_PREFUND = "upload-proof-prefund",
  UPLOAD_DISBURSEMENT_REPORT = "upload-disbursement-report",
}

export type DisbursementDataType = {
  key: PaymentKey;
  title: string;
  supportText: string;
  validations: {
    maxFileSize: {
      value: number;
      message: string;
    };
    fileType: {
      value: string[];
      message: string;
    };
  };
  rootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T;
  inputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T;
  open: () => void;
  isSuccess: boolean;
  files: { fileName: string; additionalData?: any; errors?: string[] }[];
};
